export default function ComingSoon() {
  return (
<div className="flex flex-col items-center justify-center h-screen max-w-7xl mx-auto px-6 text-center">      <h1 style={{ fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 900, fontSize: 'clamp(26px, 5vw, 52px)', color: '#1A1A1A', lineHeight: 1.25, marginBottom: '20px', letterSpacing: '-0.02em' }}>
        COMING SOON
      </h1>
      <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '15px', color: '#777', lineHeight: 1.9, marginBottom: '40px' }}>
        CaniCatiCare와 함께하는 반려동물 건강 정보 플랫폼을 준비 중입니다.<br className="hidden md:block" />
        수의사 칼럼, 치료 사례, 멤버십 콘텐츠를 곧 만나보세요.
      </p>
    </div>
  );
}
